import {
	BeckyTopology,
	BeckyFuncLibParams,
	Topology,
	FetchFn,
	SiteAssetsModuleParams,
	SiteAssetsTopologyKey,
	TopologyGetter,
	Logger,
} from '../env'

export function aTopology({
	mediaRootUrl = 'https://static.wixstatic.com/',
	staticMediaUrl = '//static.wixstatic.com/media',
	staticHTMLComponentUrl = 'https://someStaticHTMLComponentUrl.com',
	scriptsUrl = 'https://static.parastorage.com',
	fileRepoUrl = 'https://static.parastorage.com',
	siteAssetsServerUrl = 'https://siteassets.parastorage.com',
}: Partial<Topology> = {}): Topology {
	return {
		mediaRootUrl,
		staticMediaUrl,
		staticHTMLComponentUrl,
		scriptsUrl,
		fileRepoUrl,
		siteAssetsServerUrl,
	}
}

export function aBeckyTopology(
	environmentTopology: Topology = aTopology(),
	publicTopology: Topology = aTopology()
): BeckyTopology {
	return {
		environmentTopology,
		publicTopology,
	}
}

type SiteAssetsModuleParamsForRemote = Omit<SiteAssetsModuleParams, 'topologyGetter'> & {
	moduleTopology: {
		publicEnvironment: Topology
		environment: Topology
	}
}

export const aSiteAssetsModuleParamsForIT = ({
	// @ts-ignore
	metricsReporter = {
		runAsyncAndReport: jest.fn((cb) => cb()),
		runAndReport: jest.fn((cb) => cb()),
		reportError: jest.fn(),
		// @ts-ignore
		reportAsyncWithCustomKey: jest.fn((cb) => cb()),
	},
	topology = aTopology(),
	httpClient = {
		fetch: () => Promise.resolve({} as Response),
	},
	moduleFetcher = {
		fetch: () => Promise.resolve({ default: {} }),
	},
	moduleTopology = {
		environment: aTopology(),
		publicEnvironment: aTopology(),
	},
	logger = aLogger(),
}: Partial<SiteAssetsModuleParamsForRemote> = {}): SiteAssetsModuleParamsForRemote => ({
	metricsReporter,
	topology,
	moduleTopology,
	httpClient,
	moduleFetcher,
	logger,
})

export function aTopologyGetter({
	environment = (url: SiteAssetsTopologyKey) =>
		url === 'moduleRepoUrl' ? '' : aBeckyTopology().environmentTopology[url] || '',
	publicEnvironment = (url: SiteAssetsTopologyKey) =>
		url === 'moduleRepoUrl' ? '' : aBeckyTopology().publicTopology[url] || '',
}: Partial<TopologyGetter> = {}): TopologyGetter {
	return {
		environment,
		publicEnvironment,
	}
}

export function aLogger({
	debug = () => {},
	error = () => {},
	warn = () => {},
	info = () => {},
	trace = () => {},
}: Partial<Logger> = {}): Logger {
	return {
		debug,
		error,
		warn,
		info,
		trace,
	}
}

export const aSiteAssetsModuleParams = ({
	// @ts-ignore
	metricsReporter = {
		runAsyncAndReport: jest.fn((cb) => cb()),
		runAndReport: jest.fn((cb) => cb()),
		reportError: jest.fn(),
		// @ts-ignore
		reportAsyncWithCustomKey: jest.fn((cb) => cb()),
	},
	topology = aTopology(),
	httpClient = {
		fetch: () => Promise.resolve({} as Response),
	},
	moduleFetcher = {
		fetch: () => Promise.resolve({ default: {} }),
	},
	topologyGetter = aTopologyGetter(),
	logger = aLogger(),
}: Partial<SiteAssetsModuleParams> = {}): SiteAssetsModuleParams => ({
	metricsReporter,
	topology,
	topologyGetter,
	httpClient,
	moduleFetcher,
	logger,
})

export const aBeckyFuncLibParams = ({
	fetch = (() => Promise.resolve({} as Response)) as FetchFn,
	// @ts-ignore
	metricsReporter = {
		runAsyncAndReport: jest.fn((cb) => cb()),
		runAndReport: jest.fn((cb) => cb()),
		reportError: jest.fn(),
		// @ts-ignore
		reportAsyncWithCustomKey: jest.fn((cb) => cb()),
	},
}: Partial<BeckyFuncLibParams> = {}): BeckyFuncLibParams => ({
	fetch,
	metricsReporter,
})
